
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "a75dc808c69e868386a9555ab55dc7b12975b70d",
  "nuxt": {
    "buildId": "93967929-ba0b-45bc-a2fd-f992ec561fbc"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
